import {Injectable} from '@angular/core';
import { Router} from '@angular/router';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import { select, Store} from '@ngrx/store';
import {catchError,  map, switchMap, withLatestFrom} from 'rxjs/operators';
import {error} from '../../shared/actions/toasts';
import {BaseEffect} from '../../shared/effects/base.effect';
import {debug} from '../../../rxjs-operators';
import * as fromShared from '../../shared/reducers';
import {of} from 'rxjs';
import {DuplicationRuleAction, DuplicationRuleFailAction, DuplicationRuleSuccessAction, ruleDuplicateActionTypes} from '../actions/rule-duplication';
import {RulesService} from '../../contract/services/rules.service';
import {RulesMapperService} from '../../contract/services/rules-mapper.service';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class RulesDuplicateEffect extends BaseEffect {


  duplicate$ = createEffect(() => { return this.actions$.pipe(
    ofType(ruleDuplicateActionTypes.DUPLICATE),
    debug('add rules action received.'),
    map((action: DuplicationRuleAction) => action.payload ),
    switchMap((payload) =>
      this.rulesService.update(payload.contractUuid, this.rulesMapperService.formToDb(payload.ruleForm , null)).pipe(
        switchMap(() => of(new DuplicationRuleSuccessAction() )),
        catchError(res => this.catchResponseError(res)))))
  });

  duplicateSuccess$ = createEffect(() => { return this.actions$.pipe(
    ofType(ruleDuplicateActionTypes.DUPLICATE_SUCCESS),
    debug('add success rules action received.'),
    withLatestFrom(this.store.pipe(select(fromShared.selectors.getCurrentClient))),
    switchMap(() => [
    //  success(this.translation.translate('RULES_ADD_SUCCESS'), this.translation.translate('TOAST_SUCCESS_TITLE'))
    ]),
  ) });


  duplicateFail$ = createEffect(() => { return this.actions$.pipe(ofType(ruleDuplicateActionTypes.DUPLICATE_FAIL),
    debug('A server error occurred while add rules.'),
    map((err: DuplicationRuleFailAction) =>
      error(this.translation.translate('RULES_ADD_ERROR') + ' ' + err.payload, this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private rulesService: RulesService,
              private rulesMapperService: RulesMapperService,
              private store: Store<fromShared.AppState>,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new DuplicationRuleFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new DuplicationRuleFailAction(response['error'].message);
  }
}
